import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/scheduler/office-time/")({
  beforeLoad: () => {
    throw redirect({ to: "/scheduler/attendance", search: { view: "office" } });
  },
});
